import { LeaveModel, ConsultFromValues, MessageType, MessageMsgFrom, MessageMsgType, QuestionEntity } from '@tencent/dz-models';
import { ImpCoreModel } from './ImpCoreMode';
import { HistoryMessage } from 'src/interface';
import { formatCards, formatQuestions, formatMessageEntities, sleep } from 'src/utils';
import { logger } from 'src/helper';

export class ImpLeaveModel extends LeaveModel {
  // 是否存在历史消息
  public hasHisotryMessage = false;

  private coreModel: ImpCoreModel;

  constructor(coreModel: ImpCoreModel) {
    super();
    this.coreModel = coreModel;
  }

  public listenerBrower() {
    const consultModel = this.coreModel.getConsultModel();
    window.history.pushState({}, '', '#');
    window.addEventListener('popstate', () => {
      // 离开之后搜索会获取挽留问题
      if (consultModel.isFullSearch()) {
        this.fetchExitQuestionsInPopState();
        return;
      }
      // 网页的也显示挽留弹窗，但是没有问题列表
      this.visible = true;
      this.onUpdate();
    });
  }

  // 推送欢迎语, 不区分搜索网页
  public pushGreeting() {
    const consultModel = this.coreModel.getConsultModel();

    const messageModel = this.coreModel.getMessageModel();

    const config = consultModel.getConsultConfig();

    if (consultModel.isValidGreeting()) {
      messageModel.pushMessage({
        type: MessageType.Server,
        msg_type: MessageMsgType.Rich,
        msg_from: MessageMsgFrom.Server,
        payload: {
          message: config.online_greeting,
          img: config.greeting_img_url,
        },
      });
    }
  }

  // 引导消息，添加微信
  public pushStaffContact() {
    const consultModel = this.coreModel.getConsultModel();

    const messageModel = this.coreModel.getMessageModel();

    const config = consultModel.getConsultConfig();

    if (config.enable_staff_contact_show) {
      messageModel.pushMessage({
        type: MessageType.Server,
        msg_type: MessageMsgType.Rich,
        msg_from: MessageMsgFrom.Server,
        payload: {
          message: config.contact_guide_content,
          staff_wx: config.staff_wx,
          staff_tel: config.staff_tel,
        },
      });
    }
  }

  public async fetchHistoryMessage() {
    const consultModel = this.coreModel.getConsultModel();
    const messageModel = this.coreModel.getMessageModel();
    const consultConfig = consultModel.getConsultConfig();
    // 历史卡片
    messageModel.pushMessage({
      type: MessageType.HistoryCard,
      msg_from: MessageMsgFrom.Server,
      payload: {},
    });

    const url = consultModel.hitTheGray ? '/viewer/consult/history_message' : '/custom/consult/historymsg';

    const response = await this.coreModel.request.get<HistoryMessage>(url, {
      params: {
        click_id: consultModel.clickID,
        guest_id: consultModel.guestID,
        u_id: consultModel.uid,
        consult_id: consultConfig.consult_id,
        trace_id: consultModel.traceID,
      },
    });
    if (response.code !== 0) return logger.error('fetchHistoryMessage error', consultModel.guestID, document.cookie, response);

    const { data } = response;

    if (!data.size) return;

    this.hasHisotryMessage = true;

    const historyMsgData = formatMessageEntities(data.entities);

    // 获取插入位置
    const insertIndex = messageModel.getMessageIndexByType(MessageType.HistoryCard);

    // 推送系统提示
    messageModel.pushMessage({
      type: MessageType.SystemHistory,
      msg_from: MessageMsgFrom.Server,
      payload: {
        message: '以上是历史消息',
      },
    }, { insertIndex: insertIndex + 1 });
    messageModel.pushMessage(historyMsgData, { insertIndex: insertIndex + 1 });
  }

  public fetchExitQuestionsInPopState() {
    const raceFunction = async () => {
      await sleep(250);
      return this.questions;
    };
    // 超过250ms没有返回，就用原来的问题;
    Promise.race([raceFunction(), this.fetchExitQuestions()]).then((list) => {
      // 没有问题时，不显示
      if (list.length !== 0) {
        this.visible = true;
        this.updateQuestions(list);
      }
    });
  }

  // 挽留弹窗问题, 不区分搜索网页
  public async fetchExitQuestions() {
    const consultModel = this.coreModel.getConsultModel();
    const config = consultModel.getConsultConfig();

    const url = consultModel.hitTheGray ? '/viewer/consult/recommend/exit' : '/custom/consult/recommend_exit';
    const response = await this.coreModel.request.post(url, {
      consultId: config.consult_id,
      uid: consultModel.uid,
      queryWord: consultModel.queryWord,
      keyWord: consultModel.keyWord,
      pageScene: ConsultFromValues.Xj_Full,
      pvId: window.pvid,
      consultUrl: window.location.href,
      landingPageUrl: consultModel.landingUrl,
      guestId: consultModel.guestID,
    });
    const { code, data } = response;
    if (code !== 0) return this.questions;

    const list = (data.questionList || [])
      .sort((c: any, n: any) => c.serialNo - n.serialNo)
      .map((item: any) => ({ question: item.question || '' }));

    this.questions = list;
    return list as QuestionEntity[];
  }

  // 网页问题推荐逻辑
  public async fetchRecommendation() {
    const messageModel = this.coreModel.getMessageModel();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { recommend_questions_config = [] } = this.coreModel.getConsultModel().getConsultConfig();

    if (recommend_questions_config?.length) {
      messageModel.pushMessage({
        type: MessageType.QuestionRecommen,
        msg_from: MessageMsgFrom.Server,
        payload: {
          message: recommend_questions_config,
        },
      });
    }
  }

  // 搜索问题推荐逻辑， 搜索entry
  public async fetchSeachRecommendation() {
    const consultModel = this.coreModel.getConsultModel();
    const config = consultModel.getConsultConfig();

    const url = consultModel.hitTheGray ? '/viewer/consult/recommend/entry' : '/custom/consult/recommend_entry';
    return new Promise((resolve) => {
      this.coreModel.request.post(url, {
        uid: consultModel.uid,
        consultId: config.consult_id,
        queryWord: consultModel.queryWord,
        keyWord: consultModel.keyWord,
        pageScene: ConsultFromValues.Xj_Full,
        pvId: window.pvid,
        consultUrl: window.location.href,
        landingPageUrl: consultModel.landingUrl,
        guestId: consultModel.guestID,
        disease: consultModel.disease,
      }).then((res) => {
        const { code, data = {} } = res;
        if (code !== 0) resolve({});

        const { cardList = [], questionList = [] } = data;

        const { messageList, list: filterList } = formatCards(cardList || []);

        const { messageList: questionMsgList, list: questionFilterList } = formatQuestions(questionList || []);

        resolve({
          effectiveCardList: !!filterList.length,
          cardList: messageList,
          questionList: questionMsgList,
          effectiveQuestionList: !!questionFilterList.length,
        });
      });
    });
  }

  public async fetchBusinessCard() {
    const config = this.coreModel.getConsultModel().getConsultConfig();
    if (!config.card_enable) return;
    const messageModel = this.coreModel.getMessageModel();
    messageModel.pushMessage({
      type: MessageType.BusinessCard,
      msg_from: MessageMsgFrom.Server,
      payload: {
        img: config.card_img_url,
        title: config.card_title,
        content: config.card_content,
      },
    });
  }

  public pushSearchTerm() {
    const messageModel = this.coreModel.getMessageModel();
    const consultModel = this.coreModel.getConsultModel();
    const consultConfig = consultModel.getConsultConfig();
    const { preinput_enable } = consultConfig;
    const query = consultModel.queryWord || '';
    const searchQuery = `我想咨询${query}`;
    if (preinput_enable === 0) return;
    messageModel.pushMessage({
      type: MessageType.SearchTerm,
      msg_from: MessageMsgFrom.Customer,
      payload: {
        message: searchQuery,
      },
    });
  }
}
